import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Legend } from '../../../../../common/chart/legend'
import { PieChartContainer } from '../../../../../common/chart/pieChart'
import { Element } from '../../../../../common/html/element'
import { Tabs } from '../../../../../common/tabs'
import { getAppendStyleItemWithCustom } from '../../../../../common/tabs/helper'
import EventEmitter, {
  DID_MOUNT_COMPONENT,
} from '../../../../../helpers/EventEmitter'
import { getUnique, keyBy } from '../../../../../helpers/common'
import { valToPercent } from '../../../../../helpers/value'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  getYearTabs,
  handleIconDownload,
} from '../../helper'
import classes from '../../index.module.scss'
import { changeYear, selectYear } from '../../store/slice'
import { PIECHART_KEY } from './constant'
import {
  selectDataViewByEachYear,
  selectIndicatorById,
  selectYears,
} from './store/slice'

const EachYear = ({ id, isDynamicReport, year: yearSetting }) => {
  const ref = useRef()
  const chartId = useRef(getUnique())

  const dispatch = useDispatch()
  const locale = useSelector((state) => state.i18n.locale)
  const year = useSelector(selectYear(id, yearSetting))
  const data = useSelector(selectDataViewByEachYear(year))
  const dataById = keyBy(data, 'id')
  const indicatorById = useSelector(selectIndicatorById)
  const years = useSelector(selectYears)

  const tabs = getYearTabs(years)

  const [size, setSize] = useState({ width: 0, height: 0 })

  const setYear = (year) => dispatch(changeYear({ id, year }))

  useEffect(() => {
    if (
      (tabs.length && !year) ||
      !tabs.map((item) => item.key).includes(String(year))
    ) {
      setYear(tabs[tabs.length - 1]?.key)
    }
  }, [tabs.length, year])

  useEffect(() => {
    calcSize()
    window.addEventListener('resize', calcSize)
  }, [data?.length])

  useEffect(() => {
    if (size.width && isDynamicReport) {
      EventEmitter.dispatch(DID_MOUNT_COMPONENT)
    }
  }, [size.width])

  const calcSize = () => {
    setSize({
      width: ref.current?.offsetWidth || 0,
      height: ref.current?.offsetHeight || 0,
    })
  }

  const pieChartData = PIECHART_KEY.map((item) => ({
    id: item.id,
    name: indicatorById[item.id]?.ratioName || '',
    value: dataById[item.id]?.value || 0,
    color: item.color,
  }))

  const isNoData = !data?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (!year) return getNoDataComponent(isDynamicReport)

  return (
    <div
      style={{
        height: getStyleHeightContainer(isDynamicReport, isNoData, 332),
      }}
      className="flexColumn"
    >
      <Element
        style={{
          borderBottom: !isDynamicReport ? '1px solid #B5CEF8' : undefined,
        }}
        className={`dFlex justifyContentEnd ${classes.tabContainer}`}
      >
        {!isDynamicReport ? (
          <Tabs
            activeKey={year}
            items={tabs}
            tabListClassName={classes.tabs}
            getAppendStyleItem={getAppendStyleItemWithCustom()}
            isScrollContent={false}
            onChange={setYear}
          />
        ) : (
          <>
            {!isNoData && (
              <div className="fw600 py1 w100">
                <Translate value="common.FISCAL_YEAR" />: {year}
              </div>
            )}
          </>
        )}
      </Element>
      {isNoData ? (
        getNoDataComponent(isDynamicReport)
      ) : (
        <div className="h100 pt1 dFlex">
          <div ref={ref} className="h100 w50">
            <PieChartContainer
              chartId={chartId.current}
              data={pieChartData}
              width={size.width}
              height={size.height}
              innerRadius="60%"
              formatValueTooltip={(val) => valToPercent(val, locale)}
              isLabelActive={false}
            />
          </div>
          <div className="h100 w50 pl2 dFlex alignItemsCenter justifyContentCenter">
            <Legend
              chartId={chartId.current}
              items={pieChartData.map((item, index) => ({
                ...item,
                title: item.name,
                pieIndex: index,
                isI18n: false,
              }))}
              className="flexColumn"
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default EachYear
